// extracted by mini-css-extract-plugin
module.exports = {"container":"e_-x","up":"e_ay","down":"e_by","percent":"e_cy","percentVal":"e_dy","title":"e_ey","tags":"e_fy","textBadge":"e_gy"};